module.exports = __webpack_public_path__ + "static/img/xxhd.d09af67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT002/xxhd.png
// module id = 4yyh
// module chunks = 1